import React, { useState, useEffect } from 'react';
import apiService from '../../services/api';

export default function StandingsTab({ match }) {
  const [standings, setStandings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const leagueId = match.league?.id;
    if (!leagueId) { setLoading(false); return; }
    apiService.getStandings(leagueId).then(data => {
      setStandings(data);
      setLoading(false);
    });
  }, [match.league?.id]);

  if (loading) return <div className="tab-empty"><p>Loading standings...</p></div>;
  if (!standings || !standings.table) {
    return <div className="tab-empty"><p>Standings not available for this competition.</p></div>;
  }

  const homeId = match.teams.home.id;
  const awayId = match.teams.away.id;

  return (
    <div className="standings-mini">
      <div className="standings-header">
        <img src={match.league.logo} alt={match.league.name} />
        <span>{match.league.name}</span>
      </div>
      <table className="standings-table">
        <thead>
          <tr>
            <th>#</th>
            <th className="team-col">Team</th>
            <th>P</th>
            <th>W</th>
            <th>D</th>
            <th>L</th>
            <th>GD</th>
            <th>Pts</th>
          </tr>
        </thead>
        <tbody>
          {standings.table.map((row, i) => {
            const isHighlighted = row.team.id === homeId || row.team.id === awayId;
            return (
              <tr key={row.team.id} className={isHighlighted ? 'highlighted' : ''}>
                <td>{i + 1}</td>
                <td className="team-col">
                  <img src={row.team.logo} alt="" />
                  <span>{row.team.name}</span>
                </td>
                <td>{row.p}</td>
                <td>{row.w}</td>
                <td>{row.d}</td>
                <td>{row.l}</td>
                <td>{row.gd > 0 ? '+' : ''}{row.gd}</td>
                <td className="pts">{row.pts}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
